const UNIT_LABELS_SINGULAR = {
    'unidad': 'unidad',
    'kg': 'kg',
    'gr': 'gramo',
    'lt': 'litro',
    'ml': 'mililitro',
    'm2': 'metro cuadrado',
    'm3': 'metro cúbico',
    'mt': 'metro',
    'cm': 'centímetro',
    'mm': 'milímetro',
    'pulg': 'pulgada',
    'docena': 'docena',
    'caja': 'caja',
    'pack': 'pack',
    'pack x 6': 'pack x 6',
    'pack x 12': 'pack x 12',
    'pack x 24': 'pack x 24',
    'caja x 6': 'caja x 6',
    'caja x 12': 'caja x 12',
    'caja x 24': 'caja x 24',
    'rollo': 'rollo',
    'pallet': 'pallet',
    'bulto': 'bulto',
    'bolsa': 'bolsa',
    'tambor': 'tambor',
    'bidon': 'bidón',
    'display': 'display',
    'millar': 'millar',
    'resma': 'resma',
    'bobina': 'bobina',
    'atado': 'atado',
    'fardo': 'fardo',
    'set': 'set',
    'kit': 'kit',
    'par': 'par',
    'ha': 'hectárea',
    'pie2': 'pie cuadrado',
    'ton': 'tonelada',
    'lb': 'libra',
    'gal': 'galón',
    'hp': 'HP',
    'kw': 'kilowatt'
  };
  
  const UNIT_LABELS_PLURAL = {
    'unidad': 'unidades',
    'kg': 'kilogramos',
    'gr': 'gramos',
    'lt': 'litros',
    'ml': 'mililitros',
    'm2': 'metros cuadrados',
    'm3': 'metros cúbicos',
    'mt': 'metros',
    'cm': 'centímetros',
    'mm': 'milímetros',
    'pulg': 'pulgadas',
    'docena': 'docenas',
    'caja': 'cajas',
    'pack': 'packs',
    'pack x 6': 'packs x 6',
    'pack x 12': 'packs x 12',
    'pack x 24': 'packs x 24',
    'caja x 6': 'cajas x 6',
    'caja x 12': 'cajas x 12',
    'caja x 24': 'cajas x 24',
    'rollo': 'rollos',
    'pallet': 'pallets',
    'bulto': 'bultos',
    'bolsa': 'bolsas',
    'tambor': 'tambores',
    'bidon': 'bidones',
    'display': 'displays',
    'millar': 'millares',
    'resma': 'resmas',
    'bobina': 'bobinas',
    'atado': 'atados',
    'fardo': 'fardos',
    'set': 'sets',
    'kit': 'kits',
    'par': 'pares',
    'ha': 'hectáreas',
    'pie2': 'pies cuadrados',
    'ton': 'toneladas',
    'lb': 'libras',
    'gal': 'galones',
    'hp': 'HP',
    'kw': 'kilowatts'
  };

  export { UNIT_LABELS_SINGULAR, UNIT_LABELS_PLURAL };